<script lang="ts">
import FaqSection from '@/components/sections/FaqSection.vue'
import InstantWinsAndUpcomingPrizes from '@/components/sections/InstantWinsAndUpcomingPrizes.vue'
import { useFaqStore } from '@/stores/faq'
import { defineComponent } from 'vue'

export default defineComponent({
  components: {
    FaqSection,
    InstantWinsAndUpcomingPrizes,
  },
  setup() {
    return {
      faqStore: useFaqStore(),
    }
  },
})
</script>

<template>
  <AppSection class="!gap-0 !p-0">
    <InstantWinsAndUpcomingPrizes />
    <FaqSection :faq-content="faqStore.prizesFaq" />
  </AppSection>
</template>
